import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import { colours } from '../../StyleConstants'

const LassoCheckbox = styled(Checkbox)(() => ({
    color: colours.orange.orange,
    '&.Mui-checked': {
        color: colours.orange.orange,
    },
}));

export default LassoCheckbox;
